import PrivateSectionModal from "./PrivateSectionModal";

export default PrivateSectionModal;
